export default {
  chooseContentLanguage: 'Selecciona el idioma en el que crearás tu contenido',
  chooseAnotherContentLanguage: 'Selecciona un nuevo idioma para agregar a tu contenido',
  chooseALanguage: 'Selecciona un idioma',
  chooseContentType: 'Selecciona el tipo de contenido que crearás',
  chooseNewContentType: 'Selecciona el nuevo tipo de contenido',
  project: 'Proyecto',
  projectDesc: 'Los recursos se plantean en torno a un desafío o reto que siguen un orden lógico y secuenciado. Para dar respuesta a ese desafío o reto, es necesario implementar cada uno de los recursos que lo componen.',
  educationalProgram: 'Programa',
  educationalProgramDesc: 'Los recursos están conectados en torno a una temática y pueden trabajarse de forma independiente ya que no están secuenciados. Inclusive, pueden implementarse algunos y otros no.',
  save: 'Guardar y continuar',
  errors: {
    contentError: 'Debes seleccionar un tipo de contenido',
    languageError: 'Debes seleccionar un idioma',
    contentAndLanguageError: 'Debes seleccionar un idioma y un tipo de contenido'
  },
  downloadGuide: 'Guía metodológica para la creación de contenido',
  createInTeam: 'Crea en equipo',
  createDescription: '¡Tú decides! Puedes invitar a colaboradores para trabajar juntos durante el proceso de creación.',
  invite: 'Invitar colaboradores',
  invitedSuccess: '¡Has agregado a los colaboradores con éxito!'
}

export const en = {
  chooseContentLanguage: 'Select the language in which you will create your content',
  chooseAnotherContentLanguage: 'Select a new language to add to your content',
  chooseALanguage: 'Select a language',
  chooseContentType: 'Select the type of content you will create',
  chooseNewContentType: 'Select the new content type',
  project: 'Project',
  projectDesc: 'The resources are based on a challenge that follows a logical and sequential order. In order to respond to that challenge, it is necessary to implement each of the resources that compose it.',
  educationalProgram: 'Program',
  educationalProgramDesc: 'The resources are connected around a topic and can be worked on independently as they are not sequenced. In fact, some can be implemented and others not.',
  save: 'Save and continue',
  errors: {
    contentError: 'Select content type',
    languageError: 'Select language',
    contentAndLanguageError: 'Select language and content type'
  },
  downloadGuide: 'Methodological guide for content creation',
  createInTeam: 'Create in team',
  createDescription: 'You decide! You can invite collaborators to work together during the creation process.',
  invite: 'Invite collaborators',
  invitedSuccess: 'You have successfully added collaborators!'
}

export const ca = {
  chooseContentLanguage: 'Selecciona l\'idioma en el qual crearàs el teu contingut',
  chooseAnotherContentLanguage: 'Selecciona un nou idioma per afegir al teu contingut',
  chooseALanguage: 'Selecciona un idioma',
  chooseContentType: 'Selecciona el tipus de contingut que crearàs',
  chooseNewContentType: 'Selecciona el nou tipus de contingut',
  project: 'Projecte',
  projectDesc: 'Els recursos es plantegen entorn d\'un desafiament o repte que segueixen un ordre lògic i seqüenciat. Per donar resposta a aquest desafiament o repte, és necessari implementar cadascun dels recursos que ho componen.',
  educationalProgram: 'Programa',
  educationalProgramDesc: 'Els recursos estan connectats al voltant d\'una temàtica i poden treballar-se de manera independent ja que no estan seqüenciats. Inclusivament, poden implementar-se alguns i d\'altres no.',
  save: 'Desar i continuar',
  errors: {
    contentError: 'Has de seleccionar un tipus de contingut',
    languageError: 'Has de seleccionar un idioma',
    contentAndLanguageError: 'Has de seleccionar un idioma i un tipus de contingut'
  },
  downloadGuide: 'Guia metodològica per a la creació de contingut',
  createInTeam: 'Crea en equip',
  createDescription: 'Tu decideixes! Pots convidar col·laboradors per treballar junts durant el procés de creació.',
  invite: 'Convidar col·laboradors',
  invitedSuccess: 'Has afegit els col·laboradors amb èxit!'
}
